"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("../..");
exports.contentFeedDetail = graphql_tag_1.default `
  query contentFeedDetail($id: ID!) {
    contentFeed(id: $id) {
      ...contentFeedDetailData
    }
  }
  ${graphql_1.contentFeedDetailData}
`;
exports.contentFeedsList = graphql_tag_1.default `
  query contentFeedsList(
    $cmsId: ID,
    $contentMappingId: ID,
    $skip: Int,
    $take: Int,
    $archived: Boolean,
    $searchQuery: String
  ) {
    contentFeedsCount(
      cmsId: $cmsId,
      contentMappingId: $contentMappingId,
      archived: $archived
      searchQuery: $searchQuery
    )
    contentFeeds(
      cmsId: $cmsId,
      contentMappingId: $contentMappingId,
      skip: $skip,
      take: $take,
      archived: $archived,
      searchQuery: $searchQuery
    ) {
      ...contentFeedListData
    }
  }
  ${graphql_1.contentFeedListData}
`;
exports.contentItems = graphql_tag_1.default `
  query contentItems($contentFeedId: ID!, $skipCache: Boolean) {
    contentItems(contentFeedId: $contentFeedId, skipCache: $skipCache)
  }
`;
//# sourceMappingURL=contentFeeds.js.map